import React from 'react';
import {
    RichCell,
    Button, SplitLayout, SplitCol, Div, Avatar, Chip
} from '@vkontakte/vkui';
import {
    AdaptivityContext,
    CODE_SALE_POINT_MONITORING_STATUS_OFFLINE,
    getSalePointMonitoringStatuses,
    inducement
} from "../assets/constants";


import {
    Icon20AddCircleFillGreen, Icon20CopyOutline,
    Icon20EditCircleFillBlue,
} from "@vkontakte/icons";
import '@wojtekmaj/react-daterange-picker/dist/DateRangePicker.css';
import 'react-calendar/dist/Calendar.css';

import BaseList from "../components/BaseList";
import withOffline from "../components/withOffline";

import * as constants from "../assets/constants";
import Fancybox from "../assets/fancybox";
import CopyToClipBoard from "../assets/CopyToClipboardButton";
import SalePointsMonitoringsDocsManager from "../api/references/managers/SalePointsMonitoringsDocsManager";
import SalePointMonitoringDocsApi from "../api/SalePointMonitoringDocs"
import HelpButton from "../assets/HelpButton";

class SalePointMonitoringDocs extends BaseList {


    receiveMessage = (event) => {

        if (event.data === 'uploadedSalePointMonitoringDoc') {
            this.doRefresh()
        }
        if (this.props.isOffline && event.data === 'online') {
            this.doRefresh()
        }
    }
    getItems = (mainSearch = '', append = false, page = 1) => {
        clearInterval(this.searchInterval);


        this.setState({loading: true})
        append = append == undefined ? false : append
        if (page == undefined) {
            page = this.state.page;
        }
        if (mainSearch == '') {
            mainSearch = this.state.mainSearch ?? ''
        }


        SalePointsMonitoringsDocsManager.getList(
            {
                isOffline: this.props.isOffline,
                search: mainSearch,
                page,
                sp_id: this.sp_id ?? null,
                epp: AdaptivityContext.isMobile ? 10 : 20,
                start: this.state.dateValue[0].toLocaleDateString(),
                end: this.state.dateValue[1].toLocaleDateString()
            }
        ).then(response => {

            this.setState({loading: false})
            let numOffline = append ? (this.state.numOffline ?? 0) : 0
            let old = this.state.items;
            const {data} = response
            if (!append) {
                old = []
            }
            data.results.map(item => {
                old.push(item)
                const point = item.sale_point
                const statusId = (item.status !== undefined && item.k_title && point) ? item.status : CODE_SALE_POINT_MONITORING_STATUS_OFFLINE
                if (statusId === CODE_SALE_POINT_MONITORING_STATUS_OFFLINE) {
                    numOffline++
                }
            })


            this.setState({items: old, numOffline})


            this.setState({cnt_items: data.iTotalRecords})
            this.setState({totalPages: data.iTotalPages})

            if (data.iTotalPages * 1 > 0) {
                setTimeout(() => {
                    this.checkScroll()
                }, 500)
            }
        })


    }

    createItem = () => {

        const n = this.state.numOffline

        if (n > 20) {
            window.postMessage({
                type: 'error',
                timeout: 5000,
                text: `У вас уже ${n} ${inducement(n, 'документ', 'документа', 'документов')} в статусе offline! Необходимо переместится в место где есть связь и проставить документам торговые точки`
            })
            return
        }
        window.postMessage({
            type: 'setCurrentSalePointMonitoring',
            goToStep1: true,
            value: {
                doc_data: {
                    id: -1,
                    klient: null,
                    sale_point: null,
                    mall: null,
                    images: {},
                    status: null
                },
                items: [],
                questionnaire: {answers: [], sellers: []}
            }
        })
    }
    getItem = (item) => {
        SalePointMonitoringDocsApi.getOne(item.id).then(response => {
            const {data} = response

            if (data.doc_data.id) {
                window.postMessage({type: 'setCurrentSalePointMonitoring', value: data, goToStep1: true})
            }
        })
    }
    copyItem = (item) => {
        SalePointMonitoringDocsApi.getOne(item.id).then(response => {
            const {data} = response

            if (data.doc_data.id) {
                data.doc_data.id = -1
                data.doc_data.nomer = ''
                data.doc_data.date = ''
                data.doc_data.comment = ''
                data.doc_data.images = {}
                window.postMessage({type: 'setCurrentSalePointMonitoring', value: data, goToStep1: true})
            }
        })
    }

    renderToolbar = () => {
        return <div
            className={AdaptivityContext.isMobile || true ? 'mobile-table-storage-header' : 'desktop-table-storage-header'}>
            <SplitLayout>
                <SplitCol style={{justifyContent: "flex-start"}}>
                    <Div>
                        <Button mode="outline"
                                onClick={() => this.createItem()}><Icon20AddCircleFillGreen/></Button>

                    </Div>
                </SplitCol>

                <SplitCol>
                    <Div style={{display: 'flex', flexDirection: 'column'}}>
                                <span className="all-docs"
                                      id="cnt_items">Всего элементов: {this.state.cnt_items}</span>

                        {this.props.isOffline && <Chip removable={false} className="all-docs"
                                                       id="is_offline">Offline режим<HelpButton
                            text={"Нет связи с интернет. Работаем в автономном режиме"}/></Chip>
                        }

                    </Div>
                </SplitCol>
            </SplitLayout>
        </div>
    }

    constructor(props) {
        super(props);
        this.sp_id = this.props.sp_id ?? null
        this.statusLabels = getSalePointMonitoringStatuses()
        if(this.sp_id){
            this.state.dateValue[0] = new Date().addDays(-365)
        }
    }

    sp_types = constants.getSalePointsTypes()
    renderRow = (item, index) => {


        const images_url = this.props.base_url.replace("frontend/", '')


        const point = item.sale_point


        let img = null

        if (point && point.images && Array.isArray([point.images])) {
            for (let i = 0; i < point.images.length; i++) {
                if (point.images[i]) {
                    img = point.images[i]
                    break
                }
            }

        }
        const statusId = (item.status !== undefined && item.k_title && point) ? item.status : CODE_SALE_POINT_MONITORING_STATUS_OFFLINE

        //console.log(statusId, item.status, item.k_title, point)

        const statusDoc = `Статус: ${this.statusLabels[statusId]}`

        return <RichCell multiline style={{border: ((!point || !item.k_title) ? '2px solid red' : 'inherit')}}
                         subhead={[item.date + ' ' + item.time, ' ']}
                         bottom={<div style={{display: "flex", justifyContent: "space-between"}}>
                             <strong>{statusDoc ?? 'Черновик'}</strong>
                             <span style={{maxWidth: "70%", textAlign: "right"}}>{item.comment}</span>
                         </div>}
                         caption={<div style={{display: "flex", flexDirection: "column"}}>
                             <strong>{item.user ? item.user.name : (item.isOffline ? this.props.current_user.name : '')}</strong>
                             <span>{item.k_title ?? 'Клиент не указан'}</span>
                             <span>{`${point && point.mall ? 'ТЦ ' + point.mall.title + ', ' : ''}${this.sp_types[(point && point.type_ ? point.type_ : '')] ?? ''} ${point ? point.title : 'Торговая точка не указана'}${point && point.trading_floor ? ', Зал: ' + point.trading_floor : ''}`}</span>
                             <b>{point && point.full_address ? point.full_address : 'Адрес еще не указан'}</b>
                         </div>}
                         afterCaption={<div style={{display: "flex", flexDirection: "column"}}>
                             <span>{[item.items_cnt, ' ', inducement(item.items_cnt, 'позиция', 'позиции', 'позиций')]}</span>
                             {item.isOffline ?
                                 <HelpButton
                                     text={"Этот доккумент еще не отправлен на сервер потому что нет связи с интернет. Вам нужно переместится в место где есть интернет, документ сразу будет загружен и доступен для изменений"}/> :
                                 <Button mode="outline" size="m"
                                         onClick={() => this.getItem(item)}><Icon20EditCircleFillBlue/></Button>}
                             {!item.isOffline &&

                                 <Button mode="outline" size="m"
                                         onClick={() => this.copyItem(item)}><Icon20CopyOutline/></Button>}
                             <Fancybox key={'facingMonitoringFancyBox'}>
                                 <div className="main-catalog_product-wrapper_avatar"
                                      style={{width: AdaptivityContext.isMobile ? '88px' : '168px', margin: '3px'}}>
                                     {img && img.hasImage ?

                                         <a data-fancybox={'gallerySPM'+item.id}
                                            href={images_url + img.mainImage.replace('https://lab', 'https://l').replace(images_url, '')}>
                                             {<Avatar mode="image" style={{borderRadius: '5%'}}
                                                      size={AdaptivityContext.isMobile ? 80 : 160}
                                                      src={img.thumb}/>}
                                         </a> : ''}
                                 </div>
                             </Fancybox>
                         </div>
                         }>
            {item.nomer ? [item.nomer,
                <CopyToClipBoard style={{marginTop: '0px', minWidth: '36px'}}
                                 text={item.nomer}/>] : 'Номер в еще не получен'}
        </RichCell>
    }

}

export default withOffline(SalePointMonitoringDocs)